import { PublicKey } from "@solana/web3.js";

export const PRESALE_PROGRAM_PUBKEY = new PublicKey(
  // "GfPnNDqZFNNAP85tMK13oXvMmNVkvsD44YY3kmZ81uAw"
  "8edBUkpBHCfLiGHYTx346GU2orxZJJ2W8pSKbVHMTrgk"
);

export const TOKEN_PUBKEY = new PublicKey(
  // "F5yNqgEwoxzhJiKFqM1EVcyGR2ecD1nuxjkfyxBTsvLy"
  "2gZFGtav6ErKk6X8u3j9L3dHVPK1CQLvWyc1VxgVbqJj"
);

export const PRESALE_SEED = "CLUB_PRESALE_SEED";
export const USER_SEED = "CLUB_USER_SEED";
export const VAULT_SEED = "CLUB_VAULT_SEED";
export const PRESALE_ID = 2;

export const PRESALE_AUTHORITY = new PublicKey(
  "vA5iNcwaPsixKzyKppnaY7DPG6e1xcD2uiB6iSaaFmk"
);

export const TOKEN_PRESALE_HARDCAP = 200000000; // token
export const PRICE_PER_TOKEN = 0.000001; // $SOL
export const PRICE_DECIMAL = 8

export const BUYER_SOFTCAP = 0.2; // sol
export const BUYER_HARDCAP = 50; // sol
export const BUYER_TOKEN_HARDCAP = 50000000; // token

export const TOKEN_DECIMAL = 6;

export const SOL_TOKEN_PUBKEY = new PublicKey ("So11111111111111111111111111111111111111112")
export const USDC_TOKEN_PUBKEY = new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v')
export const USDT_TOKEN_PUBKEY = new PublicKey('Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB')
export const JUP_TOKEN_PUBKEY = new PublicKey('JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN')

export const SOL_PRICEFEED_ID = new PublicKey('H6ARHf6YXhGYeQfUzQNGk6rDNnLBQKrenN712K4AQJEG')
export const JUP_PRICEFEED_ID = new PublicKey('g6eRCbboSwK4tSWngn773RCMexr1APQr4uA9bGZBYfo')